import { waitingPageActions } from './WaitingAction';

const initState = {
    loadingFlags: {},
    errors: null,
    enrollmentStatus: {}
}

export default function waitingPageReducer(state=initState, action) {
    switch (action.type) {
        case waitingPageActions.setEnrollmentDetails:
            return setEnrollmentDetails(state, action);
        case waitingPageActions.setEnrollmentStatus:
            return setEnrollmentStatus(state, action);
        case waitingPageActions.setError:
            return setError(state, action);
        case waitingPageActions.toggleSpinner:
            return toggleSpinner(state, action);
        default:
            return state;
    }
}

function setEnrollmentStatus(state, {payload}) {
    return {
        ...state,
        enrollmentStatus: payload,
    }
}

function setEnrollmentDetails(state, {payload}) {
    return {
        ...state,
        enrollmentDetail: payload,
    }
}

function setError(state, {payload, meta}) {
    return {
        ...state,
        errors: {
            [meta.apiName]: payload
        },
    }
}

function toggleSpinner(state, {payload, meta}) {
    return {
        ...state,
        loadingFlags: {
            ...state.showSpinner,
            [meta.apiName]: payload
        },
    }
}